import { render } from "./MainDiscountGlobal.vue?vue&type=template&id=11a57818&scoped=true"
import script from "./MainDiscountGlobal.vue?vue&type=script&lang=js"
export * from "./MainDiscountGlobal.vue?vue&type=script&lang=js"

import "./MainDiscountGlobal.vue?vue&type=style&index=0&id=11a57818&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a57818"]])

export default __exports__